// shared/schemas/api/voiceEntry.schema.ts
import { z } from "zod";
import { NewBookingEntrySchema } from "../db/foodAndServices.schema";


export const GeminiBookingSchema = z.object({
  Transcription: z.string(),
  "Applicable Scenario": z.enum(["NewBooking", "BookingUpdate", "StandAlonePayment"]),

  "Guest Information": z.object({
    Name: z.string(),
  }),

  Booking: z.object({
    "Room Type": z.string(),
    "Room No.": z.string(), // Could be z.number() if consistently numeric
    "Planned Check-in Time": z.string().datetime(),
    "Planned Check-out Time": z.string().datetime(),
    "Actual Check-in Time": z.string().datetime().optional(),
    "Status": z.string(),
  }),

  "Booking Nights": z.array(
    z.object({
      "Stay Date": z.string(), // or z.string().regex(/^\d{4}-\d{2}-\d{2}$/)
      "Rate per Night": z.number(),
      "Room No.": z.string(), // same here
    })
  ),
});

export const VoiceEntryResponseSchema = z.object({
  sqlResult: z.string().optional(),  // Sometimes null or not returned
  entryResult: GeminiBookingSchema,
  errorMessage: z.string().nullable(),
  missingFields: z.array(z.string()),
});





export type GeminiBooking = z.infer<typeof GeminiBookingSchema>;


export const ApprovedEntrySchema = z.object({
  room_id: z.number(),
  service_date: z.string().datetime(),
  item: z.string(),
  amount: z.number(),
  remarks: z.string().optional(),
  is_complimentary: z.boolean().optional()
});


// shared/schemas/api/voiceEntry.schema.ts
export const SubmitApprovedEntryInputSchema = z.object({
  ApplicableScenario: z.enum(["NewBooking", "BookingUpdate", "StandAlonePayment"]),
  // You can expand this later to enforce shape of transformed input
  // Add more fields here if needed
}).passthrough(); // keep flexible if other fields exist

export const SubmitApprovedEntryResponseSchema = z.object({
  message: z.string(),
  result: z.any().optional(),
  missingFields: z.array(z.string()).optional(),
  error: z.boolean().optional()
});

export type SubmitApprovedEntryInput = z.infer<typeof SubmitApprovedEntryInputSchema>;
export type SubmitApprovedEntryResponse = z.infer<typeof SubmitApprovedEntryResponseSchema>;


export type VoiceEntryResponse = z.infer<typeof VoiceEntryResponseSchema>;
export type ApprovedEntryInput = z.infer<typeof ApprovedEntrySchema>;
